import React from "react";
import { Route, Routes } from "react-router-dom";
import CaseAllDataPage from "../components/_Pages/CaseAllDataPage/CaseAllDataPage";
import CaseHistoryPage from "../components/_Pages/CaseHistoryPage/CaseHistoryPage";
import CaseAccountingPage from "../components/_Pages/CaseAccountingPage/CaseAccountingPage";
import CaseFileGeneratePage from "../components/_Pages/CaseFileGeneratePage/CaseFileGeneratePage";
import CasePaidTaskPage from "../components/_Pages/CasePaidTaskPage/CasePaidTaskPage";
import CaseReferenceFilePage from "../components/_Pages/CaseReferenceFilePage/CaseReferenceFilePage";
import CasePage from "../components/_Pages/CasePage/CasePage";
import CaseRelatedActions from "../components/Case/CaseRelatedActions/CaseRelatedActions";
import CaseImportDocumentsFromPreviousInstancePage from "../components/_Pages/CaseImportDocumentsFromPreviousInstancePage/CaseImportDocumentsFromPreviousInstancePage";
import CaseImportDocumentsFromMainCasePage from "../components/_Pages/CaseImportDocumentsFromMainCasePage/CaseImportDocumentsFromMainCasePage";
import CaseExecutionJobsPage from "../components/_Pages/CaseExecutionJobsPage/CaseExecutionJobsPage";
import CaseExecutionJobDetailsPage from "../components/_Pages/CaseExecutionJobDetailsPage/CaseExecutionJobDetailsPage";
import { CallProvider } from "../provider/CallProvider";
import { DrawerProvider } from "../provider/DrawerProvider";
import CaseRouteProvider from "../provider/CaseRouteProvider";
import { AiChatProvider } from "../provider/AiChatProvider";
import { AiEventStreamProvider } from "../provider/AiEventStreamProvider";

const CaseRoutes = () => {
  return (
    <CaseRouteProvider>
      <DrawerProvider>
        <CallProvider>
          <AiEventStreamProvider>
            <AiChatProvider>
              <CaseRelatedActions />
              <Routes>
                <Route path={"/"} element={<CasePage />} />
                <Route path={"/alle-daten"} element={<CaseAllDataPage />} />
                <Route path={"/konto"} element={<CaseAccountingPage />} />
                <Route path={"/verlauf"} element={<CaseHistoryPage />} />
                <Route path={"/execution-jobs"} element={<CaseExecutionJobsPage />} />
                <Route path={"/execution-jobs/:executionJobId"} element={<CaseExecutionJobDetailsPage />} />
                <Route path={"/datei-generieren"} element={<CaseFileGeneratePage />} />
                <Route
                  path={"/dokumente-importieren/vorinstanz"}
                  element={<CaseImportDocumentsFromPreviousInstancePage />}
                />
                <Route
                  path={"/dokumente-importieren/hauptverfahren"}
                  element={<CaseImportDocumentsFromMainCasePage />}
                />
                <Route path={"/ausschreibung/:paidTaskId"} element={<CasePaidTaskPage />} />
                <Route path={"/handakte/:courtAppointmentId"} element={<CaseReferenceFilePage />} />
              </Routes>
            </AiChatProvider>
          </AiEventStreamProvider>
        </CallProvider>
      </DrawerProvider>
    </CaseRouteProvider>
  );
};

export default CaseRoutes;
